import { FC } from "react";

import { BsFillTrash3Fill } from "react-icons/bs";

import CustomButton from "../../kits/button/CustomButton";

import { pathMaker } from "../../../utils/helperFunction";

import { MessageType } from "./PrMeTypes";

import defaultImage from "../../../assets/images/default-image.jpg";

interface PreparedMessagesCardProps {
  message: MessageType;
  checked: boolean;
  deleteMessage: () => void;
  selectMessage: () => void;
}

const PreparedMessagesCard: FC<PreparedMessagesCardProps> = ({
  message,
  checked,
  deleteMessage,
  selectMessage,
}) => {
  return (
    <div className="prepared-message-card">
      <div>
        <div className="prepared-message-card-header"> انتخاب </div>
        <div className="prepared-message-card-body">
          <input type="checkbox" checked={checked} onChange={selectMessage} />
        </div>
      </div>
      <div>
        <div className="prepared-message-card-header"> متن پیام </div>
        <div className="prepared-message-card-body"> {message.text} </div>
      </div>
      <div>
        <div className="prepared-message-card-header"> دسته‌بندی </div>
        <div className="prepared-message-card-body">
          {message.category_title}
        </div>
      </div>
      <div>
        <div className="prepared-message-card-header"> دسته‌بندی </div>
        <div className="prepared-message-card-body">
          <img
            style={{
              maxWidth: "70px",
              maxHeight: "70px",
              aspectRatio: "1 / 1",
            }}
            className="rounded "
            src={
              message.file_path !== null && message.file_path !== ""
                ? pathMaker(message.file_path)
                : defaultImage
            }
            alt="prepared message"
          />
        </div>
      </div>
      <div>
        <div className="prepared-message-card-header"> عملیات </div>
        <div className="prepared-message-card-body">
          <CustomButton className="" type="text" onClick={deleteMessage}>
            <BsFillTrash3Fill size={24} color="hsl(0, 100%, 100%)" />
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default PreparedMessagesCard;
